import type { IconSvgObject } from './types';

const ShieldBlockchainIcon: IconSvgObject = [
  ["path", { d: "M11.9999 6.99994L15.9999 9.24994V13.7499L11.9999 15.9999L7.99994 13.7499V9.24994L11.9999 6.99994Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.9999 9.24994L11.9999 11.4999M7.99994 9.24994L11.9999 11.4999M11.9999 11.4999V15.9999", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3.43061 4.93443C6.56926 5.16025 8.59306 2.00103 12.0265 2.00103C15.4085 1.93395 17.0634 4.97662 20.5306 4.97662C22.3893 14.3836 18.5225 20.2927 12.0548 21.9999C6.05944 20.583 1.55464 14.6133 3.43061 4.93443Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ShieldBlockchainIcon;
